/**
 * Subscription shortcuts.
 */
import { Subscriptions } from "../features/subscriptions";
import type { MoneyValue } from "../types";

export class SubscriptionTracker {
  constructor(public readonly client: Subscriptions) {}

  /** New subscription started. */
  start(
    subscriptionId: string,
    userId: string,
    plan: string,
    mrr: MoneyValue,
    billingCycle: "monthly" | "quarterly" | "yearly"
  ) {
    return this.client.start({ subscriptionId, userId, plan, mrr, billingCycle });
  }

  /** Plan changed (upgrade / downgrade). */
  change(
    subscriptionId: string,
    userId: string,
    previousPlan: string,
    newPlan: string,
    previousMrr: MoneyValue,
    newMrr: MoneyValue,
    changeType: "upgrade" | "downgrade" | "cross_grade"
  ) {
    return this.client.change({
      subscriptionId,
      userId,
      previousPlan,
      newPlan,
      previousMrr,
      newMrr,
      changeType,
    });
  }

  /** Subscription cancelled. */
  cancel(subscriptionId: string, userId: string, plan: string, lostMrr: MoneyValue, immediate = false) {
    return this.client.cancel({ subscriptionId, userId, plan, lostMrr, immediate });
  }

  /** Subscription renewed. */
  renew(subscriptionId: string, userId: string, mrr: MoneyValue) {
    return this.client.renew(subscriptionId, userId, mrr);
  }

  /** Trial converted to paid. */
  trialConverted(
    subscriptionId: string,
    userId: string,
    plan: string,
    mrr: MoneyValue
  ) {
    return this.client.trialConverted(subscriptionId, userId, plan, mrr);
  }

  /** Trial expired without converting. */
  trialExpired(subscriptionId: string, userId: string) {
    return this.client.trialExpired(subscriptionId, userId);
  }
}
